module.exports = __webpack_public_path__ + "img/focaccia_grov.62204855.jpg";